import { Component, inject, Input, OnInit } from '@angular/core';
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { Facility, HotelInternetParking, TravelHealth } from '@core/models/domains/hotel';
import { HotelInfoUiService } from '../../../services/hotel-info-ui.service';
import { HotelFacilitiesModalComponent } from '../../../components/hotel-facilities-modal/hotel-facilities-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { ModalService } from '@shared/services/modal.service';

@Component({
 selector: 'iho-pdp-ecolodge-facilities',
 standalone: true,
    imports: [NgIf, NgFor, MatButtonModule, CommonModule],
 templateUrl: './pdp-ecolodge-facilities.component.html',
 styleUrls: ['./pdp-ecolodge-facilities.component.scss'],
})
export class PdpEcolodgeFacilitiesComponent implements OnInit {
    _dataSource: Array<Facility> = [];
     set dataSource(val: Array<Facility> | undefined) {
        if (val) {
            this._dataSource = val;
        }
    }
    @Input()  get dataSource(): Array<Facility> {
        return this._dataSource
    }
    requiredAmount = 8;

    alternativeFacilities: any[] = [];
    pdpUiService = inject(HotelInfoUiService);
    dialog = inject(MatDialog);
    @Input() travelHealth?: TravelHealth;
    modalService = inject(ModalService);
    @Input() HotelInternetParking?: any;
    @Input() type?: number;
    facilityLength = 0;
    publicFacilities: any[] = [];
    firstFacility:any[] = [];

    ngOnInit(): void {
       this.dataSource.forEach(item=>{
            if(item.HotelFacilities.length > 0){
                this.firstFacility.push(item.HotelFacilities[0]) 
            }
        });
        if(this.type != 2){
            this.alternativeFacilities.push({
                ClassName: '',
                Description: this.HotelInternetParking?.ParkingTitle,
                Id: 0,
                IconClassName: 'ico-Parking',
                ParkingClassName: this.HotelInternetParking?.ParkingClassName,
                Name: 'پارکینگ',
                PictureUrl: '',
            });
            this.facilityLength++;
            this.alternativeFacilities.push({
                ClassName: '',
                Description: this.HotelInternetParking?.InternetTitle,
                Id: 0,
                IconClassName: 'ico-Wifi',
                InternetClassName: this.HotelInternetParking?.InternetClassName,
                Name: 'اینترنت',
                PictureUrl: '',
            });
            this.facilityLength++;
            // push other facility
            this.findAlternatives(this.requiredAmount - this.facilityLength, this.publicFacilities);
        }else{
            this.alternativeFacilities.push({
                ClassName: '',
                Description: this.HotelInternetParking?.ParkingTitle,
                Id: 0,
                IconClassName: 'ico-Parking',
                ParkingClassName: this.HotelInternetParking?.ParkingClassName,
                Name: 'پارکینگ',
                PictureUrl: '',
            });
            this.alternativeFacilities.push({
                ClassName: '',
                Description: this.HotelInternetParking?.InternetTitle,
                Id: 0,
                IconClassName: 'ico-Wifi',
                InternetClassName: this.HotelInternetParking?.InternetClassName,
                Name: 'اینترنت',
                PictureUrl: '',
            });
        }
       
    }

    findAlternatives(alternativeAmount: number, publicFacilities: any[]) {
        if (publicFacilities?.length) {
            publicFacilities.forEach((item, index) => {
                if (index < alternativeAmount) {
                    if (item.Id != 8) {
                        this.alternativeFacilities.push(item);
                    }
                }
            });
        }
    }

    openModal() {
        const dialogRef = this.dialog.open(HotelFacilitiesModalComponent, {
            panelClass: [
                'custom-modal',
                'distance-modal',
                'w-screen',
                'lg:w-[600px]',
                'h-screen',
                '!max-w-full',
                'lg:h-[80%]',
            ],
            data: {
                dataSource: this._dataSource,
                hotelFullName: this.pdpUiService.hotelFullName,
                travelHealth: this.travelHealth,
                type: this.type,
                alternativeFacilities: this.alternativeFacilities,
            },
            autoFocus: false,
        });
        dialogRef.afterClosed().subscribe((result) => {
            this.modalService.isAnyModalOpen.set(false);
        });

        dialogRef.afterOpened().subscribe(() => {
            this.modalService.isAnyModalOpen.set(true);
        });
    }
    replace(ico: string) {
        if (ico.includes('_'))
            return ico.split('_')[0] + '-' + ico.split('_')[1][0].toUpperCase() + ico.split('_')[1].slice(1);
        else return ico;
    }
}
